import { formatColor, ColorFormatResult } from '@shared/utils/parsers';
import { ref } from 'vue';

export function useSavedColors() {
    const savedColors = ref<string[]>(loadColorsFromLocalStorage());

    const saveColorToLocalStorage = (color: string) => {
        const savedColors = JSON.parse(localStorage.getItem('savedColors') || '[]');
        if (!savedColors.includes(color)) {
            savedColors.push(color);
            localStorage.setItem('savedColors', JSON.stringify(savedColors));
        }
    };

    function loadColorsFromLocalStorage(): string[] {
        return JSON.parse(localStorage.getItem('savedColors') || '[]');
    }

    const addCurrentColorToSaved = (clr: { hue: number; saturation: number; lightness: number; alpha: number }) => {
        const colorString = `hsla(${clr.hue}, ${clr.saturation}%, ${clr.lightness}%, ${clr.alpha / 100})`;
        saveColorToLocalStorage(colorString);
        savedColors.value = loadColorsFromLocalStorage();
    };

    const applySavedColor = (
        color: string,
        clr: {
            hue: number;
            saturation: number;
            lightness: number;
            alpha: number;
        }
    ) => {
        const parsed = formatColor(color, 'hsl') as ColorFormatResult<HSLArray>;
        clr.hue = parsed.values[0];
        clr.saturation = parsed.values[1];
        clr.lightness = parsed.values[2];
        clr.alpha = parsed.values[3] ?? 100;
    };

    return {
        saveColorToLocalStorage,
        addCurrentColorToSaved,
        applySavedColor,
        savedColors,
    };
}
